import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/services/utils.service';
import { GateWayService } from 'src/app/services/gateway-service.service';

declare const $:any;

@Component({
  selector: 'app-manage-child-org-create',
  templateUrl: './manage-child-org-create.component.html',
  styleUrls: ['./manage-child-org-create.component.scss','../../platform-color/platform-color.scss']
})
export class ManageChildOrgCreateComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;

  image = null;
  selectFile = null;

  sizeFileOver: boolean = false;
  typeFileOver: boolean = false;

  provinces = [];
  districts = [];
  subdistricts = [];

  org_id: string;
  successModal: string = '#successModal';
  errorModal: string = '#errorModal';
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private UtilService: UtilService,
    private GateWayService: GateWayService
  ) { 
    this.route.queryParams
    .subscribe(params => {
      this.org_id = params.org_id;
    })
  }

  ngOnInit() {
    this.createForm();

    this.UtilService.getProvinces().subscribe(res=>{
      if(res.data){
        this.provinces = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];
      }
    })

    this.valueChange()
  }

  createForm(){
    this.form = this.formBuilder.group({
      name: ["", [Validators.required]],
      lat: ["", [Validators.required]],
      lon: ["", [Validators.required]],
      province_id: ["", [Validators.required]],
      province_code: [""],
      province_name_th: [""],
      subdistrict_id: ["", [Validators.required]],
      subdistrict_code: [""],
      subdistrict_name_th: [""],
      district_id: ["", [Validators.required]],
      district_code: [""],
      district_name_th: [""],
      zipcode: [""]
    })
  }

  valueChange(){
    this.form.controls.province_id.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['province_id']){

          let province = this.provinces.find(province => province.id == value);
          if(province){
            this.form.get('province_code').setValue(province.code);
            this.form.get('province_name_th').setValue(province.name_th);
          }

          this.form.get('district_id').setValue("");
          this.form.get('district_code').setValue("");
          this.form.get('district_name_th').setValue("");

          this.form.get('subdistrict_id').setValue("");
          this.form.get('subdistrict_code').setValue("");
          this.form.get('subdistrict_name_th').setValue("");
  
          this.UtilService.getDistricts(value).subscribe(res=>{
            this.districts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];
          })
        }
      }
    );

    this.form.controls.district_id.valueChanges.subscribe(
      (value) => {

       if(value != this.form.value['district_id']){
        let district = this.districts.find(district => district.id == value);
        if(district){
          this.form.get('district_code').setValue(district.code);
          this.form.get('district_name_th').setValue(district.name_th);
        }

        this.form.get('subdistrict_id').setValue("");
        this.form.get('subdistrict_code').setValue("");
        this.form.get('subdistrict_name_th').setValue("");

        this.UtilService.getSubDistricts(value).subscribe(res=>{
          this.subdistricts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];
        })
       }
      }
    );

    this.form.controls.subdistrict_id.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['subdistrict_id']){
          let subDistrict = this.subdistricts.find(subdistrict => subdistrict.id == value);

          if(subDistrict){
            this.form.get('subdistrict_code').setValue(subDistrict.code);
            this.form.get('subdistrict_name_th').setValue(subDistrict.name_th);
            this.form.get('zipcode').setValue(subDistrict.zipcode);
          }
        }
      }
    );
  }

  get f() {
    return this.form.controls;
  }

  uploadImage(){
    document.getElementById("image_file").click();
  }

  onFileChange(file){
    this.spinner.show();
    this.selectFile = <File>file[0];

    var mimeType = this.selectFile.type;
    var size = this.selectFile.size;

    if(size >= 100000000){
      this.sizeFileOver = true;
    }else{
      this.sizeFileOver = false;
    }

    if(mimeType.includes("jpeg") || mimeType.includes("png")){
      this.typeFileOver = false;
    }else{
      this.typeFileOver = true;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.selectFile); 
    reader.onload = (_event) => { 
      this.image = reader.result; 
      this.spinner.hide();
    }
  }

  deleteFile(){
    this.image = null;
  }

  async setMap(e){
    if(e){
      this.form.get("lat").setValue(e.lat);
      this.form.get("lon").setValue(e.lng);

      this.GateWayService.getLocationByPosition(`${e.lat},${e.lng}`).subscribe(res=>{
        let province = res.results.find(address=> address.types.find(type=> (type =='administrative_area_level_1')));
        let district = res.results.find(address=> address.types.find(type=> (type =='administrative_area_level_2')));
        let subDistrict = res.results.find(address=> address.types.find(type=> (type =='administrative_area_level_3')));

        if(province){
          province = province.address_components.find(address=> address.types.find(type=> (type =='administrative_area_level_1'))).long_name;
        }
        if(district){
          district = district.address_components.find(address=> address.types.find(type=> (type =='administrative_area_level_2'))).long_name;
        }
        if(subDistrict){
          subDistrict = subDistrict.address_components.find(address=> address.types.find(type=> (type =='administrative_area_level_3'))).long_name;
        }

        if(province){
          let provinceAddress = this.provinces.find(pro => province.includes(pro.name_th));
          
          if(provinceAddress){
            this.form.get('province_id').patchValue(provinceAddress.id, {emitEvent: false, onlySelf: true});
            this.form.get('province_code').patchValue(provinceAddress.code);
            this.form.get('province_name_th').patchValue(provinceAddress.name_th);

            this.UtilService.getDistricts(provinceAddress.id).subscribe(res=>{
              this.districts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

              if(district){

                district = district.replaceAll("อำเภอ","").trim();
                let districtAddress = this.districts.find(dis => dis.name_th.includes(district));

                this.form.get('district_id').patchValue(districtAddress.id, {emitEvent: false, onlySelf: true});
                this.form.get('district_code').patchValue(districtAddress.code);
                this.form.get('district_name_th').patchValue(districtAddress.name_th);
             

                if(districtAddress){
                  this.UtilService.getSubDistricts(districtAddress.id).subscribe(res=>{
                    this.subdistricts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

                    let subDistrictAddress = this.subdistricts.find(sub => subDistrict.includes(sub.name_th));

                    this.form.get('subdistrict_id').patchValue(subDistrictAddress.id, {emitEvent: false, onlySelf: true});
                    this.form.get('subdistrict_code').setValue(subDistrictAddress.code);
                    this.form.get('subdistrict_name_th').setValue(subDistrictAddress.name_th);
                    this.form.get('zipcode').setValue(subDistrictAddress.zipcode);
                  })
                }
              }
            })
          }
        }
      })
    }
  }

  save(){
    this.submitted = true;
    if(
      this.form.invalid ||
      this.sizeFileOver ||
      this.typeFileOver
    ){
      return;
    }

    if(this.selectFile){
      let formData = new FormData();
      formData.append("image", this.selectFile);
      this.UtilService.uploadImage(formData).subscribe(res=>{
        if(res.code == 200){
          this.saveChildOrg(res.data.path);
        }
      })
    }else{
      this.saveChildOrg();
    }
  }

  saveChildOrg(path = null){
    let value = this.form.value;
    let data = {
      "org_id":  this.org_id,
      "name": value.name,
      "profile_img": path? path: path,
      "subdistrict":  {
          "code" : value.subdistrict_code,
          "name_th" : value.subdistrict_name_th,
          "zipcode" : value.zipcode
      },
      "district":  {
          "code" : value.district_code,
          "name_th" : value.district_name_th,
      },
      "province":  {
          "code" : value.province_code,
          "name_th" : value.province_name_th,
      },
      "coordinates": {
          "center": {
              "lat": value.lat,
              "lon": value.lon,
              "zoom_lv": 18.0
          }
      }
    }

    this.GateWayService.createChildOrg(data).subscribe(res=>{
      if(res.code == 200){
        $(this.successModal).modal("show");
      }else{
        if(res.message == 'Data existed'){
          $(`${this.errorModal}`).modal("show");
        }
      }
    })
  }
}
